import "./App.css";
import "@swisscom/sdx/dist/css/sdx.css";
import React from "react";
import { Navigate, Route, Routes, useParams } from "react-router-dom";
import Home from "./Home.jsx";
import NotFound from "./NotFound.jsx";
import { DelistingPage } from "./Delisting/DelistingPage.jsx";

export default function SupportPage() {
  return (
    <div className="SupportPage">
      <Routes>
        <Route path="/" element={<Home />}></Route>
        <Route path="/DelistingForm" element={<DelistingPage />} />
        <Route path="/provider/bounce/*" element={<DelistingPage />} />

        {/* legacy language-prefix, redirect away from this */}
        <Route path="/:lang/*" element={<LangRedirect />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

function LangRedirect() {
  const { lang } = useParams();

  // remove the leading /:lang from the current pathname
  const restOfPath = window.location.pathname.replace(
    new RegExp(`^/${lang}`),
    ""
  );

  return <Navigate to={restOfPath || "/"} replace />;
}
